module.exports = __webpack_public_path__ + "img/image.1de7ec4a.svg";